import type { Permission } from '@ops-desk/contracts';
import type { LinkProps } from '@tanstack/react-router';
import { Inbox, type LucideIcon, Mail, Stethoscope } from 'lucide-react';

export interface NavItem {
  label: string;
  to: NonNullable<LinkProps['to']>;
  icon: LucideIcon;
  /** Item is shown only when the user holds this permission. Omit for "any signed-in user". */
  permission?: Permission;
}

// NAV REGISTRATION POINT: add or reorder navigation entries here. The header derives both the
// desktop tabs and the mobile menu from this list.
export const NAV_ITEMS: readonly NavItem[] = [
  { label: 'Submissions', to: '/submissions', icon: Inbox },
  { label: 'Service inbox', to: '/inbox', icon: Mail },
  { label: 'Medical orders', to: '/medical-orders', icon: Stethoscope },
];

/**
 * The item whose path is the longest prefix of `pathname`, so a nested route highlights its most
 * specific entry.
 */
export function activeNavItem(items: readonly NavItem[], pathname: string): NavItem | undefined {
  let best: NavItem | undefined;
  for (const item of items) {
    const path = String(item.to);
    const matches = pathname === path || pathname.startsWith(`${path}/`);
    if (matches && (!best || path.length > String(best.to).length)) best = item;
  }
  return best;
}
